import './speaker-list.scss';
import './speaker-list.html.twig';
